export default class MarketingHeroText {
  constructor(component) {
    this.dom = {
      $component: component,
      $videoToggle: component.querySelectorAll('.js-toggleModalVideo'),
      $videoPopUp: component.querySelector('.js-videoPopUp'),
      $videoPopUpUnderlay: component.querySelector('.js-modalVideoUnderlay'),
      $video: component.querySelector('.js-popUpVideo')
    }
    this.state = {
      openPopUp: false,
      openPopUpClass: 'openPopUp',
      underlayActiveClass: 'isActive'
    }
    this.videoToggleHandler = this.videoToggle.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$videoToggle.forEach($toggle => $toggle.addEventListener('click', this.videoToggleHandler))
  }

  videoToggle(e) {
    const {dom, state} = this
    e.preventDefault()

    if (state.openPopUp) {
      dom.$videoPopUp.setAttribute('aria-hidden', 'true')
      dom.$videoPopUp.setAttribute('aria-expanded', 'false')
      dom.$videoPopUp.classList.remove(state.openPopUpClass)
      dom.$videoPopUpUnderlay.classList.remove(state.underlayActiveClass)
      dom.$video.pause()
      state.openPopUp = false
    } else {
      dom.$videoPopUp.setAttribute('aria-hidden', 'false')
      dom.$videoPopUp.setAttribute('aria-expanded', 'true')
      dom.$videoPopUp.classList.add(state.openPopUpClass)
      dom.$videoPopUpUnderlay.classList.add(state.underlayActiveClass)
      dom.$video.play()
      state.openPopUp = true
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.MarketingHeroText = this
  }
}
